import React from "react";
import { useTranslation } from "react-i18next";

import { InstagramIntegrationStatusDisplay } from "./Status";
import { InstagramData } from "../../../../utils/getInstagramStatus";

export interface IStatusDisplayProps {
  instagramData: InstagramData;
  onDisconnectInstagram: () => void;
  onIntegrateInstagram: () => void;
}

export const InstagramIntegrationButtons: React.FunctionComponent<
  IStatusDisplayProps
> = (props) => {
  const { instagramData, onDisconnectInstagram, onIntegrateInstagram } = props;

  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityDetailsPage.externalIntegrations.${key}`);

  const isIntegrated = instagramData.status !== "not_connected";

  return (
    <div className="data-row buttons">
      <InstagramIntegrationStatusDisplay instagramData={instagramData} />
      {isIntegrated && (
        <button
          className="btn btn-border btn-border-red"
          onClick={onDisconnectInstagram}
        >
          {t("instagram_disconnect")}
        </button>
      )}
      {!isIntegrated && (
        <button className="btn btn-border" onClick={onIntegrateInstagram}>
          <i className="icons icon-instagram"></i>
          {t("integrate_instagram")}
        </button>
      )}
    </div>
  );
};
